/**
 * Limits Agent delegation writes to Employees with effective permission.
 * Combines the existing AI feature gates with /org/me permissions.
 * CreateTaskActions.tsx and AiAgentDelegate.tsx use this result for write controls.
 */
import { useHasEmployeePermission } from 'src/shared/permissions/useCurrentUserPermissions';

import useIsAiTaskEnabled from './useIsAiTaskEnabled';

/** Keeps permission loading and disabled AI features closed to delegation writes. */
export default function useCanDelegateToSchedulingAgent(): boolean {
  const aiTaskEnabled = useIsAiTaskEnabled();
  const { permission } = useHasEmployeePermission('CAN_DELEGATE_TO_SCHEDULING_AGENT');
  return aiTaskEnabled && permission;
}
